import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API_ROUTES from "~/api-routes";
import apiService from "~/services/service";
import { z } from "zod";
import { format } from "date-fns";

const useShareHolderRegistry = () => {
  const { id } = useParams();
  const [shareRegistryData, setShareRegistryData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [transaction, setTransaction] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [edit, setEdit] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [isAuditSidebarVisible, setAuditSidebarVisible] = useState(false);

  useEffect(() => {
    fetchShareRegistry();
  }, [page, pageSize]);

  const onPageChange = ({ page, rows }) => {
    setPage(page);
    setPageSize(rows);
  };

  const formatDate = (dateString) => {
    if (dateString) {
      return format(dateString, "MMMM do, yyyy");
    } else {
      ("-");
    }
  };

  //   fetch share registry
  const fetchShareRegistry = async () => {
    setLoading(true);
    const { data } = await apiService(
      API_ROUTES.FETCH_SHAREHOLDER_REGISTRY,
      "GET",
      {
        replace: { id, page: page + 1, pageSize },
        schema: z.object({
          id: z.string(),
          page: z.coerce.number().optional(),
          pageSize: z.coerce.number().optional(),
        }),
      },
    );
    setLoading(false);
    setTotalRecords(data.count);
    setShareRegistryData(data.rows);
  };

  //   update share registry
  const updateShareRegistryTransaction = async () => {
    setIsBtnLoading(true);
    await apiService(API_ROUTES.UPDATE_SHAREHOLDER_REGISTRY, "PUT", {
      body: JSON.stringify(transaction),
      replace: { id },
      schema: z.object({
        id: z.string(),
      }),
    });
    setTransaction({});
    fetchShareRegistry();
    setModalVisible(false);
    setEdit(false);
    setRowIndex("");
    setIsBtnLoading(false);
    setSuccessMessage("The share transaction has been updated.");
  };

  //  add share registry
  const addShareRegistryTransaction = async () => {
    setIsBtnLoading(true);
    await apiService(API_ROUTES.ADD_SHAREHOLDER_REGISTRY, "POST", {
      body: JSON.stringify({ ...transaction, shareholder: id }),
      replace: { shareholder_id: id },
      schema: z.object({
        shareholder_id: z.string(),
      }),
    });
    setTransaction({});
    fetchShareRegistry();
    setModalVisible(false);
    setEdit(false);
    setRowIndex("");
    setIsBtnLoading(false);
    setSuccessMessage(
      "The share transaction has been registered and added to the shareholder’s history.",
    );
  };

  return {
    shareRegistryData,
    setShareRegistryData,
    modalVisible,
    setModalVisible,
    transaction,
    setTransaction,
    formatDate,
    fetchShareRegistry,
    updateShareRegistryTransaction,
    addShareRegistryTransaction,
    successMessage,
    setSuccessMessage,
    edit,
    setEdit,
    rowIndex,
    setRowIndex,
    loading,
    setLoading,
    isBtnLoading,
    setIsBtnLoading,
    onPageChange,
    pageSize,
    page,
    totalRecords,
    isAuditSidebarVisible,
    setAuditSidebarVisible,
  };
};
export default useShareHolderRegistry;
